module.exports = __webpack_public_path__ + "static/media/bg1.914f582a.JPG";